import * as React from "react";
import {observer} from "mobx-react";
import {Field} from "../../../../../widgets/form/field/Field";
import {SelectInput} from "../../../../../widgets/input/select/SelectInput";
import {NumberInput} from "../../../../../widgets/input/number/NumberInput";
import type {INumericFieldSettingsDefinition, NumericFormatting} from "../../../../../../data/models/field/datatypes/Numeric";
import type {IFieldDataTypeSettingsProps} from "./IFieldDataTypeSettingsProps";

@observer
export class NumericFieldSettings extends React.Component<IFieldDataTypeSettingsProps> {
	private static readonly _options: {
		id: NumericFormatting;
		label: string;
	}[] = [
		{
			id: "general",
			label: "General",
		},
		{
			id: "comma-style",
			label: "Comma Style", // format with a thousands separator
		},
		{
			id: "currency",
			label: "Currency",
		},
		// {
		// 	id: "percentage",
		// 	label: "Percentage",
		// },
	];

	private readonly onInput = (value: number) => {
		const {field, onChange} = this.props;
		const settings = field.dataTypeSettings as INumericFieldSettingsDefinition;

		settings.decimals = value;
		onChange();
	};

	public override render() {
		const {field, onChange} = this.props;
		const settings = field.dataTypeSettings as INumericFieldSettingsDefinition;

		return (
			<>
				<Field label="Formatting">
					<SelectInput
						options={NumericFieldSettings._options}
						selected={NumericFieldSettings._options.find((option) => option.id === settings.formatting)}
						onChange={(option) => {
							settings.formatting = option.id;
							onChange();
						}}
						render={(option) => option.label}
					/>
				</Field>
				<Field
					label="Decimal Places"
					className="decimals"
				>
					<NumberInput
						key={field.refId}
						value={settings.decimals}
						onInput={this.onInput}
						onChange={this.onInput}
						decimals={0}
						min={0}
						max={10}
						onlyNaturalNumbers={true}
					/>
				</Field>
			</>
		);
	}
}
